// Per-page storytelling config for brand panel.
// Eyebrow + headline + accent word differ per page; features stay constant.
// Error pages share a simplified storytelling — no progress checklist.

export type AuthPage = "signin" | "signup" | "forgot" | "reset" | "verify";
export type ErrorPage = "404" | "403" | "500";
export type BrandPage = AuthPage | ErrorPage;

export interface BrandStorytelling {
  // i18n keys
  eyebrowKey: string;
  headlineKey: string;
  accentKey: string;
  subKey: string;
  /** Reset page: show progress checklist instead of feature list */
  showProgressChecklist?: boolean;
  /** Forgot page: show extra reassurance card below features */
  showReassuranceCard?: boolean;
}

export const STORYTELLING: Record<BrandPage, BrandStorytelling> = {
  signin: {
    eyebrowKey: "auth.signin.brand_eyebrow",
    headlineKey: "auth.signin.brand_headline",
    accentKey: "auth.signin.brand_accent",
    subKey: "auth.signin.brand_sub",
  },
  signup: {
    eyebrowKey: "auth.signup.brand_eyebrow",
    headlineKey: "auth.signup.brand_headline",
    accentKey: "auth.signup.brand_accent",
    subKey: "auth.signup.brand_sub",
  },
  forgot: {
    eyebrowKey: "auth.forgot.brand_eyebrow",
    headlineKey: "auth.forgot.brand_headline",
    accentKey: "auth.forgot.brand_accent",
    subKey: "auth.forgot.brand_sub",
    showReassuranceCard: true,
  },
  reset: {
    eyebrowKey: "auth.reset.brand_eyebrow",
    headlineKey: "auth.reset.brand_headline",
    accentKey: "auth.reset.brand_accent",
    subKey: "auth.reset.brand_sub",
    showProgressChecklist: true,
  },
  verify: {
    eyebrowKey: "auth.verify.brand_eyebrow",
    headlineKey: "auth.verify.brand_headline",
    accentKey: "auth.verify.brand_accent",
    subKey: "auth.verify.brand_sub",
  },
  "404": {
    eyebrowKey: "errors.common.brand_eyebrow",
    headlineKey: "errors.404.brand_headline",
    accentKey: "errors.404.brand_accent",
    subKey: "errors.404.desc",
  },
  "403": {
    eyebrowKey: "errors.common.brand_eyebrow",
    headlineKey: "errors.403.brand_headline",
    accentKey: "errors.403.brand_accent",
    subKey: "errors.403.desc",
  },
  "500": {
    eyebrowKey: "errors.common.brand_eyebrow",
    headlineKey: "errors.500.brand_headline",
    accentKey: "errors.500.brand_accent",
    subKey: "errors.500.desc",
  },
};
